import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'encodeBrandName',
  pure: true
})
export class EncodeBrandNamePipe implements PipeTransform {

  transform(value: string, args?: any): any {
    return this.encodeBrandName(value);
  }

  encodeBrandName(name: string): String {
    return encodeURI(name);
  }
}
